<script>
  import ViewSession from "../../ViewSession.svelte";

  let isStartFocusPeriod = false;
  let activeModal;
  export let date;
  export let year;
  export let month;
  export let sessions = [];

  function isWeekend(date) {
    return date.getDay() === 6 || date.getDay() === 0;
  }
</script>

{#if false}
  <div class="calendar-day calendar-day--is-focus-area-start">
    <a role="link" tabindex="0" class="calendar-day__button"
      ><div
        class="calendar-focus-area calendar-focus-area--start calendar-focus-area--resource"
      />
      <div class="calendar-day__header">
        <span
          class="calendar-day__number calendar-day__number--focus-area-start"
          >1</span
        ><button type="button" class="calendar-focus-area__button"
          ><span class="calendar-focus-area__name">Doble hopp</span></button
        >
      </div>
      <ul class="list-activities" /></a
    >
  </div>
{/if}

{#if date.getFullYear() !== year || date.getMonth() !== month}
  <div class="calendar-day calendar-day--is-empty" />
{:else}
  <div
    class="calendar-day {date.toISOString().slice(0, 10) ===
    new Date().toISOString().slice(0, 10)
      ? 'calendar-day--is-today'
      : ''} {isWeekend(date) ? 'calendar-day--is-weekend' : ''}"
  >
    <a
      on:click|preventDefault
      role="link"
      tabindex="0"
      class="calendar-day__button"
    >
      <div class="calendar-day__header">
        <span class="calendar-day__number">{date.getDate()}</span>
      </div>
      <ul class="list-activities">
        {#each sessions.filter((item) => item.date === date
              .toISOString()
              .slice(0, 10)) as session, index}
          <li class="list-activities__item list-activities__item--is-done">
            <a
              on:click={(e) => {
                e.preventDefault();
                activeModal = session;
              }}
              class="list-activities__link"
              href="/planer/måned/4490D164-509E-4CCA-B21D-B2784EE3E29C/2023-07-05/EDBD7668-3425-443E-B323-05A7C193847E"
              ><i
                class="list-activities__icon list-activities__icon--check"
              /><span class="list-activities__title"
                ><span>{session.name}</span></span
              >
              {#if session.comments.trim().length > 0}<i
                  class="list-activities__icon
        list-activities__icon--comment-2"
                />
              {/if}
            </a>
          </li>
        {/each}
      </ul>
    </a>
  </div>
{/if}
{#if activeModal !== undefined}
  <div class="modal" style="z-index: 100;">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <header class="modal__header">
          <button
            on:click={() => (activeModal = undefined)}
            type="button"
            class="modal__button-close"
          />
          <h1 class="h2">{activeModal?.name}</h1>
        </header>
        <ViewSession session={activeModal} />
      </div>
    </div>
  </div>
{/if}
